<template>
    <div>
        <!-- Original payment methods -->
        <template v-if="hasCurrentMethods">
            <h6 class="mb-2">Original payment methods</h6>
            <Card class="mb-4" color="light">
                <SelectedPaymentMethod
                    v-for="method in currentMethods"
                    :key="method.id"
                    :clickable="false"
                    :paymentMethod="method"
                    small
                />
            </Card>
        </template>

        <h6 class="mb-2">Choose new payment methods</h6>
        <Spinner v-if="loading" />
        <template v-else>
            <!-- Payment methods -->
            <PaymentMethodsList
                v-model="paymentMethodsToDebit"
                @completed="handleCompleted"
                @hasErrors="handleErrors"
                :amount="amount"
                :user="payerId"
                hideActions
                useBalance
            />

            <!-- Actions -->
            <Button class="mt-2 float-right" @click="submit" :disabled="disabledSubmit" :loading="loadingSubmit"
                >Update</Button
            >
        </template>
    </div>
</template>

<script>
    import { Alerts, Button, Card, Spinner } from '@tech_hexeko/design-system'
    import PaymentMethodsList from '@/components/PaymentMethods/List'
    import SelectedPaymentMethod from '@/components/layout/SelectedPaymentMethod'

    export default {
        name: 'SwitchPaymentMethods',
        emits: ['submitted'],
        components: {
            Button,
            Card,
            PaymentMethodsList,
            SelectedPaymentMethod,
            Spinner,
        },
        props: {
            currentMethods: {
                type: Array,
                default: () => [],
            },
            id: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                completed: false,
                hasErrors: false,
                loading: true,
                loadingSubmit: false,
                paymentMethodsToDebit: [],
                paymentIntent: null,
            }
        },
        computed: {
            amount() {
                return this.paymentIntent && this.paymentIntent.amount_due
            },
            disabledSubmit() {
                return this.paymentMethodsToDebit.length === 0 || !this.completed || this.hasErrors
            },
            hasCurrentMethods() {
                return Array.isArray(this.currentMethods) && this.currentMethods.length > 0
            },
            payerId() {
                return this.paymentIntent && this.paymentIntent.payer && this.paymentIntent.payer.id
            },
        },
        methods: {
            async fetchData() {
                // Get Payment Intent data
                try {
                    this.loading = true
                    this.paymentIntent = await this.$api.paymentIntents.show(this.id, {
                        includes: ['amount_due', 'payer'],
                    })
                } catch (error) {
                    let errorTxt =
                        error && error.response && error.response.data
                            ? error.response.data.message
                            : 'An error occurred while trying to fetch payment methods'
                    Alerts.notificationError(errorTxt)
                } finally {
                    this.loading = false
                }
            },
            handleCompleted(state) {
                this.completed = state
            },
            handleErrors(hasErrors) {
                this.hasErrors = hasErrors
            },
            async submit() {
                try {
                    this.loadingSubmit = true
                    await this.$api.paymentIntents.update(this.id, {
                        payment_methods: this.paymentMethodsToDebit,
                    })
                    this.$emit('submitted')
                    Alerts.notificationSuccess('Change of payment methods requested')
                } catch {
                    Alerts.notificationError('Failed to change payment methods')
                } finally {
                    this.loadingSubmit = false
                }
            },
        },
        mounted() {
            this.fetchData()
        },
    }
</script>
